var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "class-items" },
    [
      _vm._l(_vm.itemsData, function(item) {
        return [
          item.REPORT_TYPE === "H"
            ? _c("div", {
                key: item.LINE_NO,
                staticStyle: { "margin-top": "25px", "margin-bottom": "25px" },
                domProps: { innerHTML: _vm._s(item.REPORT_DESCRIPTION) }
              })
            : _c(
                "div",
                { key: item.LINE_NO, staticClass: "flex-container box" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "category-icon",
                      class: _vm.getColorClass(item.REPORT_TYPE)
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "icon" },
                        [
                          item.REPORT_TYPE === "O" &&
                          _vm.isFolderOpen(item.LINE_NO)
                            ? _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm._f("iconClass")(
                                    "REPORT-TYPE-O-open"
                                  )
                                }
                              })
                            : _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm._f("iconClass")(
                                    "REPORT-TYPE-" + item.REPORT_TYPE
                                  )
                                }
                              })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  item.REPORT_TYPE === "O"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.toggleFolder(item.LINE_NO)
                              }
                            }
                          },
                          [
                            _c("h3", [
                              _vm._v(_vm._s(item.REPORT_NAME) + " "),
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [_vm._v(_vm._s(item.FILES.length))]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        }),
                        _vm._v(" "),
                        _vm.isFolderOpen(item.LINE_NO)
                          ? _c(
                              "div",
                              { staticClass: "folder-items" },
                              [
                                !item.FILES.length
                                  ? _c("p", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.classPage.ClassItems.noFilesMessage"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(item.FILES, function(file) {
                                  return _c(
                                    "div",
                                    { key: file.REPORT_ID },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: _vm._f("iconClass")(
                                            file.CONTENT_TYPE
                                          ),
                                          "aria-hidden": "true"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: file.REPORT_URL,
                                            target: "_blank"
                                          }
                                        },
                                        [_vm._v(_vm._s(file.CONTENT_FILENAME))]
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    : item.REPORT_TYPE === "L"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: item.LINK_LOCATION,
                              target: "_blank"
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "A"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c("h3", [_vm._v(_vm._s(item.REPORT_NAME))]),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "E"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: item.REPORT_URL, target: "_blank" },
                            on: {
                              click: function($event) {
                                return _vm.logClassPageActivity(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "F"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: item.REPORT_URL, target: "_blank" },
                            on: {
                              click: function($event) {
                                return _vm.logClassPageActivity(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "P"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", target: "_blank" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToSubpage(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        )
                      ])
                    : item.REPORT_TYPE === "T"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", target: "_blank" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToForum(item)
                              }
                            }
                          },
                          [
                            _c("h3", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(item.REPORT_NAME) +
                                  " "
                              ),
                              item.NEW_ITEMS_FLG == "Y"
                                ? _c(
                                    "span",
                                    { staticClass: "badge badge-pill bg-teal" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.commonContent.newPosts"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "I"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", target: "_blank" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToLTILaunch(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE === "G"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", target: "_blank" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToGlossary(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : item.REPORT_TYPE == "D"
                    ? _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.goToAssignmentBin(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                    : _c("div", { staticClass: "content-details" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "", target: "_blank" },
                            on: {
                              click: function($event) {
                                return _vm.logClassPageActivity(item)
                              }
                            }
                          },
                          [_c("h3", [_vm._v(_vm._s(item.REPORT_NAME))])]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(item.REPORT_DESCRIPTION)
                          }
                        })
                      ])
                ]
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }